import React, { useState, useMemo, useEffect } from "react";

const DeliveryStatusFilter = ({
  deliveries,
  onFilterChange,
  activeStatus: controlledActiveStatus,
  onActiveStatusChange,
}) => {
  const [internalActiveStatus, setInternalActiveStatus] = useState("Upcoming");
  const activeStatus = controlledActiveStatus || internalActiveStatus;
  const [filteredDeliveries, setFilteredDeliveries] = useState(
    deliveries.filter((delivery) => delivery.transaction_id === 1),
  );
  
  // useEffect(() => {
  //   switch (activeStatus) {
  //     case "Upcoming":
  //       setFilteredDeliveries(
  //         deliveries.filter((delivery) => delivery.transaction_id === 1)
  //       );
  //       break;
  //     case "Delivered":
  //       setFilteredDeliveries(
  //         deliveries.filter((delivery) => delivery.transaction_id === 2)
  //       );
  //       break;
  //     case "Cancelled":
  //       setFilteredDeliveries(
  //         deliveries.filter((delivery) => delivery.transaction_id === 3)
  //       );
  //       break;
  //     default:
  //       setFilteredDeliveries(deliveries);
  //   }
  // }, [deliveries, activeStatus]);

  useEffect(() => {
    let tempDeliveries = [];
    switch (activeStatus) {
      case "Upcoming":
        tempDeliveries = deliveries.filter((delivery) => delivery.transaction_id === 1);
        break;
      case "Delivered":
        tempDeliveries = deliveries.filter((delivery) => delivery.transaction_id === 2);
        break;
      case "Cancelled":
        tempDeliveries = deliveries.filter((delivery) => delivery.transaction_id === 3);
        break;
      default:
        tempDeliveries = deliveries;
    }
    setFilteredDeliveries(tempDeliveries);
    onFilterChange?.(tempDeliveries, activeStatus);
  }, [deliveries, activeStatus, onFilterChange]);

  const deliveryStats = useMemo(() => {
    return `${filteredDeliveries.length} deliveries`;
  }, [filteredDeliveries]);

  const handleStatusChange = (status) => {
    if (onActiveStatusChange) {
      onActiveStatusChange(status);
    } else {
      setInternalActiveStatus(status);
    }
  };

  return (
    <div className="w-full space-y-4">
      {/* Status Tabs */}
      <div className="flex space-x-4 border-b border-gray-300 w-full">
        {["Upcoming", "Delivered", "Cancelled"].map((status) => (
          <button
            key={status}
            onClick={() => handleStatusChange(status)}
            className={`group pb-2 px-4 relative hover:text-[#3B0069] ${
              activeStatus === status
                ? "text-[#3B0069] font-medium"
                : "text-gray-500"
            }`}
          >
            {status}
            {activeStatus === status && (
              <div className="absolute bottom-0 left-0 w-full h-0.5 bg-[#3B0069]" />
            )}
            {activeStatus !== status && (
              <div className="absolute bottom-0 left-0 w-full h-0.5 bg-[#3B0069] opacity-0 group-hover:opacity-100" />
            )}
          </button>
        ))}
      </div>

      <div className="text-gray-600 text-sm">{deliveryStats}</div>
    </div>
  );
};

export default DeliveryStatusFilter;
